<!-- @format -->

<template>
	<div class="m-table-warp">
		<pc-mo-table-header
			v-model="searchValue"
			:search-list="searchList"
			:is-show-search-input="isShowSearchInput"
			:search-input="searchInput"
			:label-width="labelWidth"
			:label-align="labelAlign"
			:label-auto="labelAuto"
			@on-search="$emit('on-search', $event)"
			@on-search-reset="$emit('on-search-reset')"
		>
			<template #search-cpt-front="scope">
				<slot name="search-cpt-front" v-bind="scope"></slot>
			</template>

			<template #search-cpt="scope">
				<slot name="search-cpt" v-bind="scope"></slot>
			</template>

			<template #search-cpt-backend="scope">
				<slot name="search-cpt-backend" v-bind="scope"></slot>
			</template>
		</pc-mo-table-header>
		<div
			class="list-table"
			:style="{
				height: !searchList && !(isShowSearchInput && searchInput) ? '100%' : '',
			}"
		>
			<pc-mo-table
				ref="mTableRef"
				v-model:pageValue="pageValue"
				:data="data"
				:column-list="columnList"
				:loading="loading"
				:total="total"
				:show-total="showTotal"
				:show-table-btn="showTableBtn"
				:setting-column-config="settingColumnConfig"
				:can-export="canExport"
				:export-props="exportProps"
				:label-width="labelWidth"
				:label-align="labelAlign"
				:label-auto="labelAuto"
				:setting-column-align="settingColumnAlign"
				:button-front-align="buttonFrontAlign"
				:multiple="multiple"
				:row-key="rowKey"
				:collapse="collapse"
				:collapse-default="collapseDefault"
				v-bind="$attrs"
				@selection-change="(val) => $emit('selection-change', val)"
			>
				<template #check-data>
					<slot name="check-data"></slot>
				</template>

				<template #button-front>
					<slot name="button-front"></slot>
				</template>

				<template v-for="itm in columnList" :key="itm.code" #[`column-default-label-${itm.code}`]="scope">
					<slot :name="`column-default-label-${itm.code}`" v-bind="scope"></slot>
				</template>

				<template v-for="itm in columnList" :key="itm.code" #[`column-default-${itm.code}`]="scope">
					<slot :name="`column-default-${itm.code}`" v-bind="scope"></slot>
				</template>

				<template #column-default-column-setting="scope">
					<slot name="column-default-column-setting" v-bind="scope"></slot>
				</template>
			</pc-mo-table>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import type { ComponentType, SettingColumnConfigType, ExportProps } from './types';
	import PcMoTableHeader from '@/components/mobile/pc-mo-table/mo-table-header.vue';
	import PcMoTable from '@/components/mobile/pc-mo-table/mo-table.vue';

	interface Props {
		searchValue: Record<string, any>;
		isShowSearchInput?: boolean;
		searchInput?: ComponentType;
		searchList?: ComponentType[];

		data: any[];
		columnList: ComponentType[];
		loading?: boolean; // 是否加载
		total?: number; // 总数
		showTotal?: boolean;
		showTableBtn?: boolean;
		settingColumnConfig?: SettingColumnConfigType[];
		settingColumnAlign?: string;
		buttonFrontAlign?: string;
		pageValue?: {
			pageSize: number;
			pageNum: number;
		};
		canExport?: boolean;
		multiple?: boolean;
		exportProps?: {
			searchExport?: ExportProps;
			sheetExport?: ExportProps;
			allExport?: ExportProps;
		};
		labelAuto?: boolean;
		labelWidth?: string | number;
		labelAlign?: string;
		rowKey: string;
		collapse?: boolean;
		collapseDefault?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		isShowSearchInput: true,
		loading: false,
		total: 0,
		showTotal: true,
		showTableBtn: false,
	});

	const emits = defineEmits([
		'on-search',
		'on-search-reset',
		'update:searchValue',
		'update:pageValue',
		'selection-change',
	]);

	const searchValue = computed({
		get() {
			return props.searchValue;
		},
		set(val) {
			emits('update:searchValue', val);
		},
	});

	const pageValue = computed({
		get() {
			return props.pageValue;
		},
		set(val) {
			emits('update:pageValue', val);
		},
	});

	const mTableRef = ref<InstanceType<typeof PcMoTable>>();

	const getSelectionRows = () => {
		return mTableRef.value?.getSelectionRows();
	};
	const setSelectionRows = (val) => {
		mTableRef.value?.setSelectionRows(val);
	};
	defineExpose({ getSelectionRows, setSelectionRows });
</script>

<style lang="scss" scoped>
	.m-table-warp {
		position: relative;
		height: 100%;

		.list-table {
			height: calc(100% - 54px);
			overflow: auto;
			//background: #f6f6f6;
		}
	}
</style>
